module.exports = __webpack_public_path__ + "img/identificationTool.7acef679.svg";